import isEqual from 'lodash-es/isEqual'
import * as raf from 'raf'
import * as React from 'react'
import { Route } from 'react-router-dom'
import * as url from 'url'

import { reportPageView } from '../../../common/analytics'
import { IEnhancedLocation } from '../../../common/reducers/reactRouterLocation'
import fetchAllRequest from '../../../common/utils/fetchAllRequest'
import ga from '../../../common/utils/ga'
import gaSimplifiedSearchUrl from '../../../common/utils/gaSimplifiedSearchUrl'
import { Props as IPendingNavDataLoaderProps } from '../containers/pendingNavDataLoaderContainer'

class PendingNavDataLoader extends React.Component<IPendingNavDataLoaderProps> {
  public componentWillReceiveProps(nextProps: IPendingNavDataLoaderProps) {
    const {
      store,
      routes,
      alerts,
      errorPage,
      resetAlerts,
      resetErrorPage,
      setCanonicalPath,
      setUserSearchResultsViewType
    } = this.props
    const currentLocation = this.props.location
    const nextLocation = nextProps.location

    // check whether url has changed
    const navigated = !isEqual(currentLocation, nextLocation)

    if (navigated) {
      const {
        routes: nextRoutes,
        baseUrl: nextBaseUrl,
        currentSite: nextSite,
        experiments: nextExperiments
      } = nextProps

      // https://developers.google.com/analytics/devguides/collection/analyticsjs/pages#overriding
      const locationUrl =
        gaSimplifiedSearchUrl(
          nextRoutes,
          nextLocation,
          nextBaseUrl,
          nextSite,
          nextExperiments
        ) || window.location.href

      ga('set', 'location', locationUrl)

      // Reset / hide alerts when changing the route after first rendering
      if (alerts.length) {
        resetAlerts()
      }

      // Reset (remove) error page if present
      if (errorPage) {
        resetErrorPage()
      }

      // Reset canonical path to default value
      setCanonicalPath(nextLocation.pathname)

      if (
        typeof window !== 'undefined' &&
        nextLocation.query.view &&
        // query is of a type of `[propName: string]: string | string[]`
        // so it can be potentially an array
        !Array.isArray(nextLocation.query.view)
      ) {
        setUserSearchResultsViewType(nextLocation.query.view)
      }

      // @see https://github.com/envato/market-shopfront/pull/2258
      const pageView = () => raf(reportPageView)
      const promiseRequests = fetchAllRequest(store, nextLocation, routes, '')
      Promise.all(promiseRequests).then(pageView, pageView)
    }
  }

  public render() {
    const { children, location } = this.props

    return <Route location={location} render={() => children} />
  }
}

export default PendingNavDataLoader
